import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Action from '../action';
import { messages } from '../../../../../messages';
import { FormattedMessage } from 'react-intl-next';
import CrossIcon from '@atlaskit/icon/glyph/cross';
var DeleteAction = function DeleteAction(props) {
  return /*#__PURE__*/React.createElement(Action, _extends({
    content: /*#__PURE__*/React.createElement(FormattedMessage, messages.delete)
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19716
    ,
    icon: /*#__PURE__*/React.createElement(CrossIcon, {
      label: "Delete"
    }),
    testId: "smart-action-delete-action",
    tooltipMessage: /*#__PURE__*/React.createElement(FormattedMessage, messages.delete)
  }, props));
};
export default DeleteAction;